import { render, staticRenderFns } from "./Rule_6cardsPoker.vue?vue&type=template&id=5d33305c&scoped=true&"
import script from "./Rule_6cardsPoker.vue?vue&type=script&lang=js&"
export * from "./Rule_6cardsPoker.vue?vue&type=script&lang=js&"
import style0 from "./Rule_6cardsPoker.vue?vue&type=style&index=0&id=5d33305c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d33305c",
  null
  
)

export default component.exports